const banner = {
    title: '飞桨产业模型选型工具',
    desc: '飞桨产业模型选型工具凝聚了飞桨长期积累的产业实践经验，根据用户真实的产业落地诉求，对用户数据情况进行专业分析，推荐合适应用落地的模型与硬件组合，针对典型场景，还为用户推荐相关的产业实践范例。'
};

const modelParams = {
    title: '模型选型参数',
    selectorList: [
        {
            title: '场景选择',
            list: [
                {
                    label: '应用场景',
                    name: 'a',
                    isRequire: true,
                    placeholder: '请选择模型应用场景',
                    itemList: [
                        {
                            lable: '工业质检',
                            value: 'a1'
                        },
                        {
                            lable: '安防',
                            value: 'a2'
                        }
                    ]
                },
                {
                    label: '任务类别',
                    name: 'b',
                    isRequire: true,
                    placeholder: '请选择模型任务类别',
                    tips: '模型选型工具支持目标检测和语义分割的模型选型，目标检测即通过矩形框实现对目标的框选，如行人车辆检测、缺陷位置检测；语义分割为实现对图像中每一个像素的分类，能够精准描绘目标的轮廓，如人像抠图、缺陷轮廓分割',
                    itemList: [
                        {
                            lable: '目标检测',
                            value: 'b1'
                        },
                        {
                            lable: '语义分割',
                            value: 'b2'
                        }
                    ]
                }
            ]
        },
        {
            title: '模型运行要求',
            list: [
                {
                    label: '预期推理时间',
                    name: 'c',
                    isRequire: true,
                    placeholder: '请选择单张图片预期时间',
                    tips: '当前预测时间是指单张图像的预测时间，包括：前处理+预测+后处理的时间，不含图片读取和画图时间',
                    itemList: [
                        {
                            lable: '30ms及其以下',
                            value: 'c1'
                        },
                        {
                            lable: '30-50ms',
                            value: 'c2'
                        },
                        {
                            lable: '50-100ms',
                            value: 'c3'
                        },
                        {
                            lable: '100-150ms',
                            value: 'c4'
                        },
                        {
                            lable: '150ms以上',
                            value: 'c5'
                        }
                    ]
                },
                {
                    label: '部署系统',
                    isRequire: true,
                    name: 'd',
                    placeholder: '请选择部署使用系统',
                    itemList: [
                        {
                            lable: 'windows10',
                            value: 'd1'
                        },
                        {
                            lable: 'linux(x86)',
                            value: 'd2'
                        }
                    ]
                },
                {
                    label: '精度和速度',
                    name: 'f',
                    isRequire: true,
                    placeholder: '请选择精度和速度',
                    tips: '该项为用户对于精度和速度的需求的需求。指定“更侧重于精度”，则优先推荐精度指标较高的模型；指定“更侧重于速度”，则优先推荐运行时间较短的模型；指定“速度精度均衡”，则优先推荐精度指标与运行时间的比值较大的模型。',
                    itemList: [
                        {
                            lable: '速度精度均衡',
                            value: 'f1'
                        },
                        {
                            lable: '更侧重于精度',
                            value: 'f2'
                        },
                        {
                            lable: '更侧重于速度',
                            value: 'f3'
                        }
                    ]
                },
                {
                    label: '部署硬件',
                    name: 'e',
                    isRequire: false,
                    placeholder: '请选择模型部署的硬件',
                    itemList: [
                        {
                            lable: '3090',
                            value: 'e1'
                        },
                        {
                            lable: '2080Ti',
                            value: 'e2'
                        },
                        {
                            lable: '1080Ti',
                            value: 'e3'
                        },

                        {
                            lable: '1660S',
                            value: 'e4'
                        }
                    ]
                }
            ]
        },
        {
            title: '数据分析',
            list: []
        }
    ]
};

// 创建一个IIFE来对modelParams做一个初始化处理
(() => {
    const customScene = sessionStorage.getItem('application_scene');

    if (customScene && Object.keys(JSON.parse(customScene)).includes('a3')) {
        const sceneData = JSON.parse(customScene) as { a3: string };
        modelParams.selectorList[0].list[0].itemList[2] = {
            lable: sceneData['a3'],
            value: 'a3'
        };
    }
})();

const dataAnalyze = {
    upload: {
        label: '数据上传',
        btnWord: '文件上传'
    },

    dataFeature: {
        label: '数据特点',
        placeholder: '请选择符合描述的数据特点',
        list: [
            {
                label: '样本分布不均衡'
            },
            {
                label: '小目标'
            },
            {
                label: '密集型'
            },
            {
                label: '无以上特点'
            }
        ]
    }
};

const getFeatureResult = (strList: string[] | undefined) => {
    if (!strList) {
        return 'g9';
    }
    let result = 'g9';
    let item = strList.join(',');
    switch (item) {
        case '样本分布不均衡,小目标':
            result = 'g1';
            break;
        case '样本分布不均衡':
            result = 'g2';
            break;

        case '小目标':
            result = 'g3';
            break;

        case '无以上特点':
            result = 'g4';
            break;

        case '样本分布不均衡,小目标,密集型':
            result = 'g5';
            break;

        case '样本分布不均衡,密集型':
            result = 'g6';
            break;

        case '小目标,密集型':
            result = 'g7';
            break;

        case '密集型':
            result = 'g8';
            break;
        default:
            result = 'g9';
    }
    return result;
};

const datasetArr = [
    {
        label: 'labelme标注数据格式',
        descArr: [
            '1. 需要选定包含标注文件的zip格式压缩包。zip格式压缩包中包含一个annotations文件夹，文件夹中的内容为与标注图像相同数量的json文件，每一个json文件除后缀外与对应的图像同名。',
            '2. 支持检测与分割任务。若提供的标注信息与所选择的任务类型不匹配，则将提示错误。',
            '3. 对于检测任务，需提供rectangle类型标注信息；对于分割任务，需提供polygon类型标注信息。'
        ],
        imageUrl: 'https://paddle-site-web-video.cdn.bcebos.com/paddle-smrt-images/1.%20labelme.png'
    },
    {
        label: '精灵标注数据格式',
        descArr: [
            '1. 需要选定包含标注文件的zip格式压缩包。zip格式压缩包中包含一个annotations文件夹，文件夹中的内容为与标注图像相同数量的json文件，每一个json文件除后缀外与对应的图像同名。',
            '2. 支持检测与分割任务。若提供的标注信息与所选择的任务类型不匹配，则将提示错误。',
            '3. 对于检测任务，需提供bndbox或polygon类型标注信息；对于分割任务，需提供polygon类型标注信息。'
        ],
        imageUrl:
            'https://paddle-site-web-video.cdn.bcebos.com/paddle-smrt-images/2.%20%E7%B2%BE%E7%81%B5%E6%A0%87%E6%B3%A8.png'
    },
    {
        label: 'labelimg标注数据格式',
        descArr: [
            '1. 需要选定包含标注文件的zip格式压缩包。zip格式压缩包中包含一个annotations文件夹，文件夹中的内容为与标注图像相同数量的xml文件，每一个xml文件除后缀外与对应的图像同名。',
            '2. 仅支持检测任务。',
            '3. 标注文件中必须提供bndbox字段信息；segmentation字段是可选的。'
        ],
        imageUrl: 'https://paddle-site-web-video.cdn.bcebos.com/paddle-smrt-images/3.labelimg.png'
    },
    {
        label: 'voc数据格式',
        descArr: [
            '1. 需要选定包含标注文件的zip格式压缩包。zip格式压缩包中包含一个annotations文件夹，文件夹中的内容为与标注图像相同数量的xml文件，每一个xml文件除后缀外与对应的图像同名。',
            '2. 仅支持检测任务。',
            '3. 标注文件中必须提供bndbox字段信息；segmentation字段是可选的。'
        ],
        imageUrl: 'https://paddle-site-web-video.cdn.bcebos.com/paddle-smrt-images/4.voc.png'
    },
    {
        label: 'coco数据格式',
        descArr: [
            '1. 需要选定包含标注文件的zip格式压缩包。zip格式压缩包中包含一个annotations文件夹，文件夹中仅存在一个名为annotation.json的文件。',
            '2. 支持检测与分割任务。若提供的标注信息与所选择的任务类型不匹配，则将提示错误。',
            '3. 对于检测任务，标注文件中必须包含bbox字段，segmentation字段是可选的；对于分割任务，标注文件中必须包含segmentation字段。'
        ],
        imageUrl: 'https://paddle-site-web-video.cdn.bcebos.com/paddle-smrt-images/aaaaddddd.png'
    },
    {
        label: 'seg数据格式',
        descArr: [
            '1. 需要选定包含标注文件的zip格式压缩包。zip格式压缩包中包含一个annotations文件夹，文件夹中的内容为与标注图像相同数量的png文件，每一个png文件除后缀外与对应的图像同名。',
            '2. 仅支持分割任务。',
            '3. 标注文件需要与原始图像在像素上严格保持一一对应，格式只可为png（后缀为.png或.PNG）。标注文件中的每个像素值为Ύ,255]区间内从0开始依序递增的整数ID，除255外，标注ID值的增加不能跳跃。在标注文件中，使用255表示需要忽略的像素，使用0表示背景类标注。'
        ],
        imageUrl: 'https://paddle-site-web-video.cdn.bcebos.com/paddle-smrt-images/6.seg.png'
    }
];

const statementDesc = [
    '使用及免责声明：',
    '在使用模型选型工具提供的数据分析功能（以下简称“本功能”）前，请您务必仔细阅读并理解透彻本《使用及免责声明》（以下简称“本声明”）。请您知悉，如果您选择继续使用本功能，意味着您充分知悉并接受以下使用条件：',
    '无论是否实际阅读本声明，您通过网络页面点击生成模型推荐的服务，均表示您与我方已就本声明达成一致并同意接受本声明的全部约定内容。如果您不同意本声明的任意内容，或者无法准确理解我方对本声明条款的解释，请不要同意或使用本服务。否则，表示您已接受了以下所述的条款和条件，同意受本声明约束。',
    '本功能处于前沿探索阶段，本功能是为了帮助用户进一步分析当前数据特点，推荐更好的模型，仅供非商业目的使用。',
    '我们尊重并保护所有使用本服务用户的个人隐私，但此提醒用户：您确认使用本服务时输入的内容将不包含任何个人信息。同时，请您务必确保上传、输入内容未侵害任何人合法权益。',
    '本功能承诺不对测试使用者上传的任何信息进行存储。',
    '您确认并知悉本功能生成的所有内容都是由人工智能模型生成，我们对其生成分析结果的准确性、完整性和功能性不做任何保证。',
    '您理解并同意，基于本功能产生的知识产权与相关权益，均归我方或我方关联公司所有。',
    '您应理解并同意，本功能仅处于测试体验、试用阶段，尚存在不完备性，我方不对本功能的任何可用性、可靠性做出任何承诺。我方不对您使用本功能或本功能结果承担任何责任，且本功能结果不代表我方立场。',
    '我方有权因为业务发展或法律法规的变动而随时对本功能的内容和/或提供方式进行变动，或者暂停或终止本功能。您同意我方将不对因上述情况导致的任何后果，向您或第三方承担任何责任。',
    '在任何情况下，我方均不就因本功能所发生的任何直接性、间接性、后果性、惩戒性、偶然性、特殊性的损害(包括但不限于：您使用本功能而遭受的利润损失)，承担任何责任(即使您已事先被告知该等损害发生的可能性)。',
    '若您违反本声明任何约定，则我方有权随时单方面终止本声明，且我方无需承担任何责任。同时，我方有权根据实际损失向您请求赔偿。',
    '除双方另有约定外，本声明之解释与适用，以及与本声明有关的争议，均依照中华人民共和国法律予以处理(不包含冲突法)，并由我方所在地有管辖权的人民法院管辖。'
];

export { banner, modelParams, dataAnalyze, getFeatureResult, datasetArr, statementDesc };
